
import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';

const EnquiryFAQSection = ({ data }) => {
    const [openFAQ, setOpenFAQ] = useState(null);

    if (!data) return null;
    const { title, subtitle, items } = data;

    const toggleFAQ = (index) => {
        setOpenFAQ(openFAQ === index ? null : index);
    };

    return (
        <section className="px-6 py-12 max-w-3xl mx-auto">
            <div className="text-center mb-12">
                <h2 className="text-3xl font-bold text-[#8A1C23] mb-4">{title}</h2>
                <p className="text-lg text-gray-600">
                    {subtitle}
                </p>
            </div>

            <div className="space-y-2">
                {items?.map((faq, index) => (
                    <div key={index} className="group transition-all duration-300">
                        <button
                            className="flex justify-between items-center cursor-pointer py-4 border-b border-gray-200 w-full text-left font-medium text-[#8A1C23] hover:text-[#6B1419] transition-colors"
                            onClick={() => toggleFAQ(index)}
                            aria-expanded={openFAQ === index}
                        >
                            <span className="leading-relaxed">{faq.question}</span>
                            {openFAQ === index ? (
                                <ChevronUp className="w-5 h-5 flex-shrink-0" />
                            ) : (
                                <ChevronDown className="w-5 h-5 flex-shrink-0" />
                            )}
                        </button>
                        {openFAQ === index && (
                            <div className="text-sm text-gray-600 mt-2 pb-4 leading-relaxed">
                                {faq.answer}
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </section>
    );
};

export default EnquiryFAQSection;